module.exports = __webpack_public_path__ + "img/grabpay.9ae260e6.png";